import { useDebouncedValue } from "@mantine/hooks"
import { Spotlight } from "@mantine/spotlight"
import { useRouter } from "next/navigation"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useAuth, useUsers } from "@/hooks"
import { filterUser, prepareQuery } from "@/utils"
import { UserLine } from "../people"
import classes from "./AppSpotlight.module.css"
import { InputLoader } from "./InputLoader"
import { icons } from "./icons"

export function AppSpotlight() {
  const { t } = useTranslation()

  const { user } = useAuth()
  const { push } = useRouter()
  const { users, isPending } = useUsers()

  const [search, setSearch] = useState("")
  const [value] = useDebouncedValue(search, 300)
  if (!user) return null

  const queries = prepareQuery(value)
  const items = users
    .filter((u) => filterUser(queries, u))
    .slice(0, 10)
    .map((u) => (
      <Spotlight.Action key={u.id} className={classes.action} onClick={() => push(`/people/${u.id}`)}>
        <UserLine user={u} />
      </Spotlight.Action>
    ))

  return (
    <Spotlight.Root query={search} onQueryChange={setSearch}>
      <Spotlight.Search
        leftSection={<icons.Search />}
        rightSection={<InputLoader loading={isPending} />}
        placeholder={t("Type user name/email/position")}
      />
      <Spotlight.ActionsList>
        {items.length > 0 ? items : <Spotlight.Empty>{t("Nothing found")}</Spotlight.Empty>}
      </Spotlight.ActionsList>
    </Spotlight.Root>
  )
}
